import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  addAccountPriority,
  addProfileImage,
  login,
  userlogout,
} from "../../redux/userSlice";
import "./LoginComponent.css";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
// import images
import logo from "../../assets/images/logo.svg";
import axios from "axios";
import { toast } from "react-toastify";
import LoaderModal from "../ModalLoader/LoaderModal";
import { persistor } from "../../redux/store";
import { resetTheme } from "../../redux/themeSlice";

const LoginComponent = () => {
  // for loading modal ==>
  const [showModal, setShowModal] = useState(false);

  const [registerCheck, setRegisterCheck] = useState(false);

  const APi_Url = process.env.REACT_APP_ENIGMA_API;

  const dispatch = useDispatch();

  const naviagtion = useNavigate();

  const initialValues = {
    userName: "",
    password: "",
  };

  const validationSchema = Yup.object({
    userName: Yup.string()
      .email("Invalid email format")
      .required("Email is Required")
      .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        "Email domain must be a valid domain"
      ),
    password: Yup.string()
      .min(6, "Password must be at least 6 characters")
      .required("Password is Required"),
  });

  const storeToken = (token) => {
    const tokenData = {
      value: token,
      timestamp: new Date().getTime(),
    };
    sessionStorage.setItem("token", JSON.stringify(tokenData));
  };
  const [defaultPassword, setDefaultPassword] = useState("Enigma@1234");

  // const fetchDefaultpasword = async () => {
  //   setShowModal(true);
  //   try {
  //     const response = await axios.get(
  //       `${APi_Url}api/admin/Show-Default-Password`,

  //       {
  //         headers: {
  //           Accept: "application/json",
  //           // "Content-Type": "application/json",
  //           "Content-Type": "multipart/form-data",
  //         },
  //       }
  //     );
  //     if (response.status === 200) {
  //       setDefaultPassword(response?.data?.response?.password);
  //       setShowModal(false);
  //     }
  //   } catch (error) {
  //     console.error("Error uploading image:", error);
  //     setShowModal(false);
  //   }
  // };

  const [createAccountDisplayOnWebsite, setcreateAccountDisplayOnWebsite] =
    useState();
  const getAllDocuSign = async () => {
    setShowModal(true);
    try {
      const response = await axios.get(
        `${APi_Url}api/account/get-all-docusign`,

        {
          headers: {
            Accept: "application/json",
            // "Content-Type": "application/json",
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response.status === 200) {
        // console.log(
        //   "resposne get all docusign list ",
        //   response?.data?.response[0]
        // );

        setcreateAccountDisplayOnWebsite(
          response?.data?.response[0].createAccountDisplayOnWebsite
        );

        setShowModal(false);
      }
    } catch (error) {
      console.error("Error uploading image:", error);
      setShowModal(false);
    }
  };

  useEffect(() => {
    // fetchDefaultpasword();
    getAllDocuSign();
  }, []);
  const [resendEmail, setResendEmail] = useState();
  const onSubmit = async (values, { setSubmitting }) => {
    dispatch(userlogout());
    dispatch(resetTheme());
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("userRole");
    setShowModal(true);

    const email = values.userName;
    setResendEmail(values.userName);
    const password = defaultPassword;
    const token =
      "4bd64e434292798ff43ae9707e0fb0625ec67333d6b283baa00dde26de01f8b0";
    const data = JSON.stringify(values);

    // Check Deafult Password start
    try {
      const response = await axios.post(`${APi_Url}api/auth/login`, data, {
        headers: {
          Accept: "*",
          Accept: "application/json",
          "Content-Type": "application/json",
          secure: false,
          changeOrigin: true,
        },
      });
      // New login proces intgration start

      const defaultPasswordData = {
        email: values.userName,
        password: defaultPassword,
        token:
          "4bd64e434292798ff43ae9707e0fb0625ec67333d6b283baa00dde26de01f8b0",
      };
      try {
        const response = await axios.post(
          `${APi_Url}api/auth/check-default-password`,
          defaultPasswordData,
          {
            headers: {
              Accept: "*",
              Accept: "application/json",
              "Content-Type": "application/json",
              secure: false,
              changeOrigin: true,
            },
          }
        );

        // console.log('Response:', response);
        if (response?.data?.response == true) {
          naviagtion(`/defaultPassword/${email}`);
          setShowModal(false);
        } else {
          // Login api old
          const data = JSON.stringify(values);
          try {
            const response = await axios.post(
              `${APi_Url}api/auth/login`,
              data,
              {
                headers: {
                  Accept: "*",
                  Accept: "application/json",
                  "Content-Type": "application/json",
                  secure: false,
                  changeOrigin: true,
                },
              }
            );

            const responseToken = response.data.response.token;
            const statusCode = response.data.statusCode;
            const userDetails = response.data.response.userDetails;
            // console.log("getusers",userDetails.getusers[0])
            if (statusCode === 200) {
              if (userDetails.role == "Dev") {
                // naviagtion("/dashboard");
                // sign  chceking api start

                try {
                  const response = await axios.get(
                    `${APi_Url}api/auth/check-mail-esignature/${email}`,
                    {},
                    {
                      headers: {
                        Accept: "*",
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        secure: false,
                        changeOrigin: true,
                      },
                    }
                  );

                  if (
                    response.data.statusCode == 200 &&
                    response.data.success == true
                  ) {
                    naviagtion("/dashboard");
                    toast.success("Successfully Login");
                    storeToken(responseToken);
                    sessionStorage.setItem("userRole", userDetails.role);

                    dispatch(
                      login({
                        user: {
                          id: userDetails.userId,
                          role: userDetails.role,
                          userEmail: userDetails.userEmail,
                          firstName: userDetails.getusers[0].firstName,
                          lastName: userDetails.getusers[0].lastName,
                          token: responseToken,
                        },
                      })
                    );
                    dispatch(addProfileImage(userDetails.profileImageUrl));
                    // dispatch(addAccountPriority('update'));
                    setShowModal(false);
                  } else {
                    // status modal registration true
                    setRegisterCheck(true);
                  }
                } catch (error) {
                  setShowModal(false);
                  toast.error(error?.response?.data?.errorMassage[0]);
                }

                // sign  chceking api end
              } else if (userDetails.role == "Admin") {
                naviagtion("/admin/user");
                toast.success("Successfully Login");
                storeToken(responseToken);
                sessionStorage.setItem("userRole", userDetails.role);

                dispatch(
                  login({
                    user: {
                      id: userDetails.userId,
                      role: userDetails.role,
                      userEmail: userDetails.userEmail,
                      firstName: userDetails.getusers[0].firstName,
                      lastName: userDetails.getusers[0].lastName,
                      token: responseToken,
                    },
                  })
                );
                dispatch(addProfileImage(userDetails.profileImageUrl));
                // dispatch(addAccountPriority('update'));
                setShowModal(false);
              }
            }
            // Handle response data as needed
          } catch (error) {
            setShowModal(false);
            toast.error(error?.response?.data?.errorMassage[0]);
          } finally {
            setShowModal(false);
            setSubmitting(false); // Make sure to reset form state, if applicable
          }
        }
      } catch (error) {
        setShowModal(false);
        toast.error(error?.response?.data?.errorMassage[0]);
      } finally {
        setShowModal(false);
        setSubmitting(false); // Make sure to reset form state, if applicable
      }

      // Handle response data as needed
    } catch (error) {
      setShowModal(false);
      toast.error(error?.response?.data?.errorMassage[0]);
    } finally {
      setShowModal(false);
      setSubmitting(false); // Make sure to reset form state, if applicable
    }

    // check deafult password end
  };

  // const dispatch = useDispatch();
  // const userStatus = useSelector(userMode);

  // const handleToggle = () => {
  //   dispatch(toggleUsers());
  // };

  // let location = useLocation();
  // if (userStatus) {
  //   return <Navigate to="/dashboard" state={{ from: location }} />;
  // }

  const resendMail = async () => {
    try {
      const response = await axios.get(
        `${APi_Url}api/auth/resend-mail-esignature/${resendEmail}`,
        {},
        {
          headers: {
            Accept: "*",
            Accept: "application/json",
            "Content-Type": "application/json",
            secure: false,
            changeOrigin: true,
          },
        }
      );

      if (response.data.statusCode == 200 && response.data.success == true) {
        toast.success(response.data.response);
      }
    } catch (error) {
      setShowModal(false);
      toast.error(error?.response?.data?.errorMassage[0]);
    }
  };
  return (
    <>
      <div className="sign_in_wrp">
        <div className="sign_in_wrp_cntnr">
          <div className="sign_in_innr">
            <div className="sign_in_innr_wrp">
              <div className="img_prt">
                <img src={logo} alt="logo_icon" />
                <h2> Welcome </h2>
              </div>
              <div className="cnct_prt">
                <div className="sign_in_cnct">
                  <div className="sgn_pg_lgo"></div>
                  <div className="frm_wrp">
                    <h6>Login to your Account</h6>
                    <Formik
                      initialValues={initialValues}
                      validationSchema={validationSchema}
                      onSubmit={onSubmit}
                    >
                      {({ isSubmitting }) => (
                        <Form>
                          <div className="frm_fld">
                            <label>email</label>

                            <Field
                              type="email"
                              id="userName"
                              name="userName"
                              placeholder="userName"
                              className="input"
                            />
                            <ErrorMessage
                              name="userName"
                              component="div"
                              className="error_msg"
                            />
                          </div>
                          <div className="frm_fld">
                            <label>password</label>

                            <Field
                              type="password"
                              id="password"
                              name="password"
                              placeholder="Password"
                              className="input"
                            />
                            <ErrorMessage
                              name="password"
                              component="div"
                              className="error_msg"
                            />
                          </div>
                          <div className="frm_fld frgt_prt">
                            <Link to={"/forgotpassword"}>Forgot Password</Link>
                          </div>
                          <div className="frm_fld">
                            <input
                              type="submit"
                              disabled={isSubmitting}
                              value="login"
                            />
                          </div>
                          {createAccountDisplayOnWebsite && (
                            <div className="frm_fld crt_btn_fld">
                              <Link to={"/signup"} className="crt_btn">
                                CREATE ACCOUNT
                              </Link>
                            </div>
                          )}
                        </Form>
                      )}
                    </Formik>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* modal for sign api start */}

        <div
          className={`modal fade inputmodal ${registerCheck ? "show" : ""}`}
          aria-hidden="true"
          style={{ display: registerCheck ? "block" : "none" }}
          tabIndex="-1"
          role="dialog"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body">
                <h4 className="document-message">
                  You must have received an Email to {resendEmail}.<br /> Kindly
                  check your email for a copy of our Terms and Conditions. You
                  need to accept the terms to proceed ahead.
                  <br />
                  <br />
                  If you are unable to locate this email kindly reach out to us
                  at client.support@smarttradingblueprint.com
                </h4>

                <div className="col-12">
                  <button
                    className="btn kevlar_btn"
                    type="submit"
                    onClick={() => {
                      setRegisterCheck(false);
                      naviagtion("/");
                    }}
                  >
                    Ok
                  </button>
                </div>
                <div
                  className="resend"
                  onClick={() => {
                    resendMail();
                  }}
                >
                  <Link>Resend</Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* modal for sign api end */}
      </div>
      <LoaderModal show={showModal} />
    </>
  );
};

export default LoginComponent;

// LoginComponent

// <button onClick={handleToggle}>
// {userStatus?"Logout":"Login"}
// </button>
